import {
  openPhotoSwipe
} from './photoswipe';
import * as Swal from 'sweetalert2';
import {
  onComponentList,
  normalizeComponents
} from './tag-manager/gtm';
import trans from './i18n';

window.openPhotoSwipe = openPhotoSwipe;

window.selectVoce = function (marca, modello, ania, versioni, link) {
  // const options = {};
  // versioni.forEach(el => {
  //     options[el.slug] = el.descrEx;
  // });
  const options = [`<option value=""></option>`];
  versioni.forEach((el) => {
    options.push(`<option value="${el.slug}">${el.descrEx}</option>`);
  });
  const select = `<select id="swal-version" class="swal2-select mt-2">${options.join(
    ''
  )}</select>`;
  Swal.fire({
    confirmButtonColor: '#28a745',
    cancelButtonColor: '#d2d1d2',
    reverseButtons: true,
    focusConfirm: true,
    allowEnterKey: false,
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-black',
    },
    buttonsStyling: false,
    icon: 'info',
    showCancelButton: true,
    confirmButtonText: trans('form-input.continua'),
    cancelButtonText: trans('js-files.indietro'),
    allowOutsideClick: false,
    html: `<p class="m-0">` +
      trans('js-files.sel-versione-proseguire') +
      `</p>
        ${select}
        <p class="m-0">` +
      trans('js-files.oppure-inserisci-targa') +
      `</p>
        <div class="license-wrapper my-1 mx-auto" data-country="it" style="width:200px">
            <input class="not-found__search-input form-control" name="license_number" placeholder="AB 123 CD"
                   type="text" id="swal-targa">
        </div>
        <div id="swal-recaptcha" style="display:inline-block"></div>`,
    onOpen: () => {
      grecaptcha.render('swal-recaptcha', {
        sitekey: recaptchaSiteKey,
      });
    },
    preConfirm: () => {
      const version = document.getElementById('swal-version').value;
      const targa = document.getElementById('swal-targa').value;
      return new Promise((resolve) => {
        if (!version && !targa) {
          Swal.showValidationMessage('Versione o targa obbligatori');
        } else if (!version && targa) {
          if (!targa.match(/^[a-zA-Z]{2,3}[0-9A-Za-z]{4,6}$/)) {
            Swal.showValidationMessage('Targa non valida');
          } else if (grecaptcha && grecaptcha.getResponse().length === 0) {
            Swal.showValidationMessage(trans('js-files.cod-ver-invalid'));
          }
        }
        resolve({
          version: version,
          targa: targa,
        });
      });
    },
  }).then((result) => {
    if (!result.dismiss) {
      if (result.value.version) {
        window.location.href = link
          .replace('slug1', `${marca}-${modello}-${result.value.version}`)
          .replace('slug2', ania);
      } else if (result.value.targa) {
        window.location.href =
          licenseLink +
          `?license_number=${
            result.value.targa
          }&g-recaptcha-response=${grecaptcha.getResponse()}&ania=${ania}`;
      }
    }
  });
};

document.addEventListener('DOMContentLoaded', function () {
  if (typeof products === 'object' && products.data.length > 0) {
    onComponentList(normalizeComponents(products.data, 'category-list'));
  }
});